<template>
  <div class="app-store-button">
    <a :href="appStoreLink" target="_blank">
      <BaseImage
        :src="`button-${store}.svg`"
        class="app-store-image"
        :alt="storeContent.imageAlt"
      />
    </a>
    <div class="rating mt-1">
      <BaseStarRating :rating="storeContent.rating" />
      <BaseText class="rating-score"> ({{ storeContent.ratingText }})</BaseText>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseStarRating from "~/components/atoms/BaseStarRating.vue";

const props = defineProps<{
  store: "app-store" | "google-play";
}>();

const host = useCurrentHost();

const translateWithHost = useTranslateWithHost();

const storeContent = computed(() => {
  const ratingKey = props.store === "app-store" ? "app.app-store-rating" : "app.play-store-rating";
  const ratingText = translateWithHost(ratingKey);

  return {
    rating: Number(ratingText),
    ratingText,
    imageAlt: translateWithHost(`app.${props.store}-alt`),
  };
});

const appStoreLink = computed(() => {
  if (props.store === "app-store") {
    switch (host.value) {
      case "allefolders":
        return "https://apps.apple.com/nl/app/allefolders/id1086601848/";
      case "myshopi":
        return "https://apps.apple.com/be/app/myshopi-folders-promoties/id406663341";
      case "promopromo":
        return "https://apps.apple.com/nl/app/promopromo-folders-van-belgi%C3%AB/id811303467";
    }
  } else {
    switch (host.value) {
      case "allefolders":
        return "https://play.google.com/store/apps/details?id=com.jafolders.allefolders";
      case "myshopi":
        return "https://play.google.com/store/apps/details?id=com.agilys.myshopi";
      case "promopromo":
        return "https://play.google.com/store/apps/details?id=com.jafolders.promopromo";
    }
  }
});
</script>

<style lang="scss" scoped>
.app-store-button {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.app-store-image {
  max-height: 3.25rem;
  max-width: 9rem;
}

.rating {
  display: flex;
  color: $light-100;
  align-items: center;

  .rating-score {
    font-size: 1rem;
    font-weight: 600;
    margin-left: 0.5rem;
  }
}
</style>
